<template>
    <div class="block-editor attachment-input">
        <div class="title">Trigger only if the user sends</div>
        <a-select :value="clone.fileType" @change="(e) => (clone.fileType = e)" class="select-filetype">
            <a-select-option value="image">{{ $t("chatbotv2.imageAttachment") }}</a-select-option>
            <a-select-option value="audio">{{ $t("chatbotv2.audioAttachment") }}</a-select-option>
            <a-select-option value="video">{{ $t("chatbotv2.videoAttachment") }}</a-select-option>
            <a-select-option value="document">{{ $t("chatbotv2.documentAttachment") }}</a-select-option>
            <a-select-option value="any">{{ $t("chatbotv2.anyAttachment") }}</a-select-option>
        </a-select>
        <div class="attribute-picker-section">
            <span class="sectionTitle"> Save the file URL to the attribute</span>
            <a-popover
                v-model="attributePickerVisible"
                trigger="click"
                :overlayClassName="'no-padding'"
                placement="left"
            >
                <div slot="content">
                    <AttributePicker :default-selected="clone.alias" :pick="onAttributePicked" />
                </div>
                <div class="attribute-input">
                    <div class="attribute-input-text-wrapper">
                        <div class="attribute-input-placeholder" v-if="$_.isEmpty(clone.alias)">
                            {{ $t("chatbotv2.chooseAttributeType") }}
                        </div>
                        <div class="single-attribute-style" v-else :class="{ active: attributePickerVisible }">
                            <AttributeIconPreview :attribute="clone.alias" />
                            <span>{{
                                `${clone.alias}`.startsWith("akinon_") || Attributes.includes(clone.alias)
                                    ? $t(`chatbotv2.attr.${clone.alias}`)
                                    : clone.alias
                            }}</span>
                        </div>
                    </div>
                    <span class="material-icons" v-if="!$_.isEmpty(clone.alias)"> expand_more </span>
                </div>
            </a-popover>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import AttributePicker from "../pickers/AttributePicker";
import _ from "lodash";
import AttributeIconPreview from "../common/AttributeIconPreview";
import { Attributes } from "../../../palatteEnums";

const log = log2("AttachmentInput");
export default {
    name: "AttachmentInput",
    components: { AttributePicker, AttributeIconPreview },
    props: {
        value: {
            type: Object,
            default: () => ({
                fileType: String, // image, video, audio,document, file
                alias: String,
            }),
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            attributePickerVisible: false,
            Attributes,
        };
    },
    methods: {
        onAttributePicked(attribute) {
            log("onAttributePicked", attribute);
            this.clone = Object.assign({}, this.clone, { alias: attribute });
            this.attributePickerVisible = false;
        },
    },
    mounted() {
        log("mounted");
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.attachment-input {
    padding: 30px 30px 105px;

    .title {
        margin-bottom: 5px;
        color: #22272d;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
    }

    .select-filetype {
        width: 100%;
        height: 43px;

        .ant-select-selection--single {
            height: 43px;
            cursor: pointer;
            display: flex;
            align-items: center;
        }
    }

    .attribute-picker-section {
        margin-top: 20px;

        .sectionTitle {
            margin-bottom: 10px;
            margin-top: 15px;
            color: #22272d;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .attribute-input {
            align-items: center;
            background: #fff;
            border: 1px solid #c6cdd4;
            border-radius: 6px;
            cursor: pointer;
            display: flex;
            height: 43px;
            padding: 15px;
            position: relative;
            transition: all 0.3s;
            user-select: none;
            width: 100%;

            &:hover {
                border: 1px solid #006cff !important;
            }

            .attribute-input-text-wrapper {
                display: flex;
                flex-grow: 1;
                width: 0;
            }

            .attribute-input-placeholder {
                color: #9ba6b3;
                font-size: 15px;
                line-height: 19px;
                overflow: hidden !important;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .single-attribute-style {
                background: #ffdc66;
                cursor: pointer;
                transition: all 0.3s;
                border-radius: 10px;
                box-decoration-break: clone;
                padding: 0 8px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-weight: 800;

                &.active {
                    background: #006cff;
                    color: #fff;

                    .material-icons {
                        color: #fff;
                    }
                }

                .material-icons {
                    color: #647283;
                    font-size: 18px;
                    margin-right: 3px;
                }
            }
        }
    }
}
</style>
